export default "__VITE_ASSET__bf9045aa__"